import { render, staticRenderFns } from "./JChartWrapper.vue?vue&type=template&id=0f675afc&scoped=true&"
import script from "./JChartWrapper.vue?vue&type=script&lang=ts&"
export * from "./JChartWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./JChartWrapper.vue?vue&type=style&index=0&id=0f675afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f675afc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VBtn,VDialog,VIcon,VProgressCircular})
